
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetFlashStatusRequest extends APIRequest
{
    getMsisdn(): string;
}

export class GetFlashStatusRequestImpl extends APIRequestDtoImpl implements GetFlashStatusRequest
{
    constructor(private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
       return this.msisdn;
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashstatus/getflashstatusrequest.tsx